import React, { useState, useEffect } from 'react';
import "./Rightpart.css";
import profile from "../assets/images/profile.png";
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from '../../api/axios';
import { Link, useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

export default function ManageRight() {
  const [user, setUser] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Add Address Modal States
  const [showAddModal, setShowAddModal] = useState(false);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [formAddress, setFormAddress] = useState("");
  const [formCountry, setFormCountry] = useState("");
  const [formState, setFormState] = useState("");
  const [formCity, setFormCity] = useState("");
  const [formPostalCode, setFormPostalCode] = useState("");
  const [formPhone, setFormPhone] = useState("");
  const [formSubmitting, setFormSubmitting] = useState(false);

  const handleProfileUpdate = () => {
    const userData = localStorage.getItem("user");
    if (userData) {
      setUser(JSON.parse(userData));
    }
  };

  const fetchAddresses = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      navigate("/login");
      return;
    }
    try {
      setLoading(true);
      const res = await axios.get("/user/shipping/address");
      if (res.data && res.data.data) {
        setAddresses(res.data.data);
      }
      setLoading(false);
    } catch (err) {
      console.error("Error fetching addresses:", err);
      setLoading(false);
    }
  };

  const fetchCountries = async () => {
    try {
      const res = await axios.get("/countries");
      if (res.data && res.data.data) {
        setCountries(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching countries:", err);
    }
  };

  useEffect(() => {
    handleProfileUpdate();
    window.addEventListener("user-profile-updated", handleProfileUpdate);

    fetchAddresses();
    fetchCountries();

    return () => {
      window.removeEventListener("user-profile-updated", handleProfileUpdate);
    };
  }, []);

  const handleCountryChange = async (countryId) => {
    setFormCountry(countryId);
    setFormState("");
    setFormCity("");
    setStates([]);
    setCities([]);

    if (!countryId) return;

    try {
      const res = await axios.get(`/states-by-country/${countryId}`);
      if (res.data && res.data.data) {
        setStates(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching states:", err);
    }
  };

  const handleStateChange = async (stateId) => {
    setFormState(stateId);
    setFormCity("");
    setCities([]);

    if (!stateId) return;

    try {
      const res = await axios.get(`/cities-by-state/${stateId}`);
      if (res.data && res.data.data) {
        setCities(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching cities:", err);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    localStorage.removeItem("wishlist_slugs");
    window.dispatchEvent(new Event("user-profile-updated"));
    window.dispatchEvent(new Event("wishlist-slugs-updated"));
    axios.get("/auth/logout").catch(() => {});
    navigate("/login");
  };

  const handleMakeDefault = async (id) => {
    try {
      const res = await axios.post("/user/shipping/make_default", { id });
      if (res.data && res.data.result) {
        alert("Default address updated successfully!");
        fetchAddresses();
      }
    } catch (err) {
      console.error("Error making address default:", err);
    }
  };

  const handleDeleteAddress = async (id) => {
    if (!window.confirm("Are you sure you want to delete this address?")) return;
    try {
      const res = await axios.get(`/user/shipping/delete/${id}`);
      if (res.data && res.data.result) {
        alert("Address deleted successfully!");
        fetchAddresses();
      } else {
        alert(res.data.message || "Failed to delete address.");
      }
    } catch (err) {
      console.error("Error deleting address:", err);
    }
  };

  const handleCreateAddress = async (e) => {
    e.preventDefault();
    try {
      setFormSubmitting(true);
      const res = await axios.post("/user/shipping/create", {
        address: formAddress,
        country_id: formCountry,
        state_id: formState,
        city_id: formCity,
        postal_code: formPostalCode,
        phone: formPhone
      });

      if (res.data && res.data.result) {
        alert("Address added successfully!");
        setShowAddModal(false);
        // Reset form
        setFormAddress("");
        setFormCountry("");
        setFormState("");
        setFormCity("");
        setFormPostalCode("");
        setFormPhone("");
        fetchAddresses();
      } else {
        alert(res.data.message || "Failed to save address.");
      }
      setFormSubmitting(false);
    } catch (err) {
      console.error("Error adding address:", err);
      alert(err.response?.data?.message || "Something went wrong.");
      setFormSubmitting(false);
    }
  };

  return (
    <div className='order-detail-main-outer'>
      <div className='order-detail-content'>
         <div className='dashbord-header'>
            <p className='title-dash'>Manage Address</p>
          <div className="dropdown-section d-flex align-items-center">
            <div className="dropdown">
              <button
                className="btn dropdown-toggle d-flex align-items-center gap-3"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="profile-name">
                  <img src={user?.avatar_original || user?.avatar || profile} alt="" style={{ width: '40px', height: '40px', borderRadius: '50%' }} />
                  <div className="name-mail">
                    <h4>{user?.name || "User"}</h4>
                    <p>{user?.email || user?.phone || "Email/Phone"}</p>
                  </div>
                </div>
                <ExpandMoreIcon />
              </button>

              <ul className="dropdown-menu ">
                <li>
                  <Link className="dropdown-item" to="/profile">
                    Profile
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/support">
                    Support
                  </Link>
                </li>
                <li>
                  <button onClick={handleLogout} className="dropdown-item w-100 text-start border-0 bg-transparent">
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          </div>
         </div>
         <div className='outer-box-oc'>
               <div className='row'>
                 {loading ? (
                   <div className="col-12 text-center py-5">
                     <div className="spinner-border text-dark" role="status">
                       <span className="visually-hidden">Loading addresses...</span>
                     </div>
                   </div>
                 ) : addresses.length === 0 ? (
                   <div className="col-lg-7 col-12 text-muted py-5 text-center">
                     <h5>No saved addresses.</h5>
                     <p>Add a shipping address to checkout quickly!</p>
                   </div>
                 ) : (
                   addresses.map((addr) => (
                     <div className='col-lg-7 col-12 mb-4' key={addr.id}>
                         <div className='address-manager'>
                           <div className='box-top'>
                             <div className='sr-number d-flex align-items-center gap-2'>
                                 <h4>Address</h4>
                                 {addr.set_default === 1 && (
                                   <span className="badge bg-dark" style={{ fontSize: '10px' }}>Default</span>
                                 )}
                             </div>
                             <div className='sr-date pyment-invoice dropdown'>
                                 <button className="btn btn-link p-0 text-dark" data-bs-toggle="dropdown" aria-expanded="false" style={{ border: 'none', background: 'none' }}>
                                   <MoreVertIcon/>
                                 </button>
                                 <ul className="dropdown-menu dropdown-menu-end">
                                   {addr.set_default !== 1 && (
                                     <li>
                                       <button className="dropdown-item" onClick={() => handleMakeDefault(addr.id)}>Make Default</button>
                                     </li>
                                   )}
                                   <li>
                                     <button className="dropdown-item text-danger" onClick={() => handleDeleteAddress(addr.id)}>Delete</button>
                                   </li>
                                 </ul>
                             </div>
                           </div>
                           <div className='billing-text'>
                             <div className='icon-info mb-2'>
                                <FmdGoodOutlinedIcon />
                                <p>{addr.address}, {addr.city_name}, {addr.state_name}, {addr.country_name} - {addr.postal_code}</p>
                             </div>
                             {addr.phone && (
                               <div className='icon-info small text-muted'>
                                 <p className="mb-0">Phone: {addr.phone}</p>
                               </div>
                             )}
                           </div>
                         </div>
                     </div>
                   ))
                 )}

                 <div className='col-lg-5 col-12'>
                    <div className='address-manager'>
                      <div className='box-top'>
                        <div className='sr-number'>
                            <h4>Add Address</h4>
                        </div>
                      </div>
                      <div className='add-adres billing-text' style={{ cursor: 'pointer' }} onClick={() => setShowAddModal(true)}>
                         <span><AddIcon/></span>
                      </div>
                    </div>
                 </div>
               </div>
         </div>
      </div>

      {/* Add Address Modal */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add New Address</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleCreateAddress}>
            <Form.Group className="mb-3">
              <Form.Label>Address Detail</Form.Label>
              <Form.Control 
                as="textarea" 
                rows={3} 
                placeholder="Street address, building, apartment..." 
                value={formAddress} 
                onChange={(e) => setFormAddress(e.target.value)} 
                required 
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Country</Form.Label>
              <Form.Select 
                value={formCountry} 
                onChange={(e) => handleCountryChange(e.target.value)} 
                required
              >
                <option value="">Select Country</option>
                {countries.map(c => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>State</Form.Label>
              <Form.Select 
                value={formState} 
                onChange={(e) => handleStateChange(e.target.value)} 
                required
                disabled={!formCountry}
              >
                <option value="">Select State</option>
                {states.map(s => (
                  <option key={s.id} value={s.id}>{s.name}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>City</Form.Label>
              <Form.Select 
                value={formCity} 
                onChange={(e) => setFormCity(e.target.value)} 
                required
                disabled={!formState}
              >
                <option value="">Select City</option>
                {cities.map(c => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Postal Code</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="e.g. 302020" 
                value={formPostalCode} 
                onChange={(e) => setFormPostalCode(e.target.value)} 
                required 
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Phone number..." 
                value={formPhone} 
                onChange={(e) => setFormPhone(e.target.value)} 
                required 
              />
            </Form.Group>

            <div className="d-flex justify-content-end gap-2 mt-4">
              <Button variant="secondary" onClick={() => setShowAddModal(false)}>
                Cancel
              </Button>
              <Button variant="dark" type="submit" disabled={formSubmitting}>
                {formSubmitting ? "Saving..." : "Save Address"}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  )
}
